import { AnalyticsEvent } from '@beat-venues/common-types';
import { createContext, ReactNode, useEffect, useState } from 'react';

// Extend the Window interface to include the dataLayer property
declare global {
    interface Window {
        dataLayer: AnalyticsEvent[];
    }
}

interface AnalyticsProviderState {
    dataLayer: AnalyticsEvent[];
    pushEventToDataLayer?: (event: AnalyticsEvent) => void;
}

const initialState: AnalyticsProviderState = {
    dataLayer: [],
};

export const AnalyticsContext =
    createContext<AnalyticsProviderState>(initialState);

interface AnalyticsProviderProps {
    children: ReactNode;
}

export const AnalyticsProvider = ({ children }: AnalyticsProviderProps) => {
    const [dataLayer, setDataLayer] = useState<AnalyticsEvent[]>([]);

    useEffect(() => {
        window.dataLayer = window.dataLayer || dataLayer;
    }, [dataLayer]);

    const pushEventToDataLayer = (event: AnalyticsEvent) => {
        setDataLayer([...dataLayer, event]);
        window.dataLayer.push(event);
    };

    return (
        <AnalyticsContext.Provider
            value={{ dataLayer, pushEventToDataLayer: pushEventToDataLayer }}
        >
            {children}
        </AnalyticsContext.Provider>
    );
};
